import { QueryClientProvider } from 'react-query'
import queryClient from './queryClient'

const ReactQueryProvider: React.FC = ({ children }) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
)

export default ReactQueryProvider
